module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_3016.f8b1522b.png";